var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.75,
    height: 20.75,
    viewBox: "0 0 20.75 20.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M10.375,11.672A5.836,5.836,0,1,0,4.539,5.836,5.837,5.837,0,0,0,10.375,11.672Zm5.188,1.3H13.329a7.055,7.055,0,0,1-5.909,0H5.188A5.187,5.187,0,0,0,0,18.156V18.8A1.946,1.946,0,0,0,1.945,20.75H18.8A1.946,1.946,0,0,0,20.75,18.8v-.648A5.187,5.187,0,0,0,15.563,12.969Z",
    fill: "#b2b1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.a936cf956b7f71b69723f32f4caa876f.svg";
export { ForwardRef as ReactComponent };